export default __webpack_public_path__ + "static/PricingImage-f5d3513e6cb03dd1e94f8e16d8b78a2e.webp";